
import '../footer/about.css';
import './Ajutor.css';
import { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faHeadset,
  faEnvelope,
  faQuestionCircle,
  faComments,
  faCheckCircle,
  faClock,
  faPhone
} from "@fortawesome/free-solid-svg-icons";

const Ajutor = () => {
  const [formData, setFormData] = useState({
    nume: '',
    email: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus('sending');
    
    // Aici va fi logica de trimitere la backend
    // Deocamdata simulam trimiterea
    setTimeout(() => {
      setSubmitStatus('success');
      setFormData({ nume: '', email: '', message: '' });
      
      // Resetam mesajul de succes dupa 5 secunde
      setTimeout(() => setSubmitStatus(''), 5000);
    }, 1000);
  };

  return (
    <div className="general-container-footer-info-ab">
      <div className="info-footer-container-ab">
        
     

        <div className='tittle-ab-top'>
          <h4>Contact</h4>
        </div>

        {/* Introducere */}
        <section className='section-about-2'>
          <div className='part-image-about'>
            <FontAwesomeIcon icon={faHeadset} className='icon-about-large ajutor-icon-large' />
          </div>
          <div className='part-text-about'>
            <h4>Cum te putem ajuta?</h4>
            <p>
              Echipa ContaLearn este aici pentru tine! Daca ai intrebari despre platforma, cursuri,
              cont sau orice alta problema, nu ezita sa ne contactezi.
            </p>
            <p>
              Completeaza formularul de mai jos si iti vom raspunde in cel mai scurt timp posibil,
              de obicei in maximum 48 de ore lucratoare.
            </p>
            <p>
              <strong>Important:</strong> Pentru intrebari frecvente, consulta mai intai pagina noastra de
              <a href='/faq' className='ajutor-inline-link'> Intrebari Frecvente</a> -
              poate gasesti raspunsul imediat!
            </p>
          </div>
        </section>

        {/* Formular de contact */}
        <section className='section-about-2'>
          <div className='part-text-about ajutor-full-width'>
            <h4>
              <FontAwesomeIcon icon={faEnvelope} className='ajutor-title-icon' />
              Trimite-ne un mesaj
            </h4>
            
            {submitStatus === 'success' && (
              <div className='ajutor-success-box'>
                <FontAwesomeIcon icon={faCheckCircle} className='ajutor-success-icon' />
                <div>
                  <strong>Mesaj trimis cu succes!</strong>
                  <p className='ajutor-success-text'>Iti vom raspunde in maximum 48 de ore lucratoare.</p>
                </div>
              </div>
            )}

            <form onSubmit={handleSubmit} className='ajutor-form'>
              <div className='ajutor-form-group'>
                <label htmlFor="nume" className='ajutor-label'>
                  Nume si prenume *
                </label>
                <input
                  type="text"
                  id="nume"
                  name="nume"
                  value={formData.nume}
                  onChange={handleChange}
                  placeholder="Ex: Ion Popescu"
                  required
                  className='ajutor-input'
                />
              </div>

              <div className='ajutor-form-group'>
                <label htmlFor="email" className='ajutor-label'>
                  Adresa de email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="exemplu@email.ro"
                  required
                  className='ajutor-input'
                />
              </div>

              <div className='ajutor-form-group'>
                <label htmlFor="message" className='ajutor-label'>
                  Mesajul tau *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Descrie problema sau intrebarea ta cat mai detaliat..."
                  required
                  rows="6"
                  className='ajutor-input ajutor-textarea'
                />
              </div>

              <button
                type="submit"
                disabled={submitStatus === 'sending'}
                className={`ajutor-submit-btn ${submitStatus === 'sending' ? 'ajutor-submit-btn-sending' : ''}`}
              >
                <FontAwesomeIcon icon={faEnvelope} />
                {submitStatus === 'sending' ? 'Se trimite...' : 'Trimite mesajul'}
              </button>

              <p className='ajutor-required-text'>
                * Campuri obligatorii
              </p>
            </form>
          </div>
        </section>

        {/* Diferenta fata de FAQ */}
        <section className='section-about-2'>
          <div className='part-image-about'>
            <FontAwesomeIcon icon={faQuestionCircle} className='icon-about-large ajutor-icon-large' />
          </div>
          <div className='part-text-about'>
            <h4>Intrebari Frecvente vs Contact Direct</h4>
            <div className='ajutor-contact-grid'>
              <div className='ajutor-contact-card'>
                <h5 className='ajutor-card-title'>
                  <FontAwesomeIcon icon={faQuestionCircle} className='ajutor-card-title-icon' />
                  Intrebari Frecvente
                </h5>
                <ul className='ajutor-list-no-bullets'>
                  <li>Raspunsuri imediate</li>
                  <li>Intrebari comune</li>
                  <li>Disponibil 24/7</li>
                  <li>Auto-servire</li>
                </ul>
                <a href='/faq' className='ajutor-card-link'>
                  Consulta pagina -&gt;
                </a>
              </div>
              
              <div className='ajutor-contact-card'>
                <h5 className='ajutor-card-title'>
                  <FontAwesomeIcon icon={faComments} className='ajutor-card-title-icon' />
                  Contact Direct (aceasta pagina)
                </h5>
                <ul className='ajutor-list-no-bullets'>
                  <li>Probleme specifice</li>
                  <li>Raspuns personalizat</li>
                  <li>Suport dedicat</li>
                  <li>48h raspuns</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Alte moduri de contact */}
        <section className='section-about-2'>
          <div className='part-text-about'>
            <h4>Alte modalitati de contact</h4>
            <div className='ajutor-contact-methods'>
              <div className='ajutor-contact-row'>
                <FontAwesomeIcon icon={faEnvelope} className='ajutor-contact-icon' />
                <div>
                  <strong>Email direct:</strong> suport@contalearn.ro
                </div>
              </div>
              <div className='ajutor-contact-row'>
                <FontAwesomeIcon icon={faClock} className='ajutor-contact-icon' />
                <div>
                  <strong>Program raspuns:</strong> Luni - Vineri, 09:00 - 18:00
                </div>
              </div>
              <div className='ajutor-contact-row ajutor-contact-row-last'>
                <FontAwesomeIcon icon={faCheckCircle} className='ajutor-contact-icon' />
                <div>
                  <strong>Timp mediu de raspuns:</strong> Maximum 48 ore lucratoare
                </div>
              </div>
            </div>
            <p className='ajutor-note-text'>
              <strong>Nota:</strong> Pentru probleme urgente legate de cont, te rugam sa ne contactezi direct la suport@contalearn.ro
              mentionand "URGENT" in subiect.
            </p>
          </div>
          <div className='part-image-about'>
            <FontAwesomeIcon icon={faPhone} className='icon-about-large ajutor-icon-large' />
          </div>
        </section>

        <div className='line-about'></div>
      </div>
    </div>
  );
};

export default Ajutor;
